import styled from "styled-components";
import { Box, List, token, ListItem, textStyles } from "@bynder/design-system";
const EmptyStateWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	min-width: 350px;
	min-height: 200px;
`;
const StickyHeader = styled.div`
	position: sticky;
	top: 0;
	background-color: white;
	z-index: 1;
`;
const ActionsWrapper = styled.div`
	position: absolute;
	top: 0;
	right: 16px;
	z-index: 1;
`;
const BoxGrow = styled(Box)`
	flex: 1;
`;
const ListStyled = styled(List)`
	overflow: hidden;
`;
const DropdownWrapper = styled.div`
	margin-top: ${token.spacing3};
	margin-right: ${token.spacing5};
`;
const ListItemStyled = styled(ListItem)`
	position: relative;
`;
const Title = styled.div`
	${textStyles.paragraphS}

	white-space: break-spaces;
`;
const Subtitle = styled.div`
	${textStyles.paragraphS}
	margin-bottom: ${token.spacing3};
	color: ${token.gray500a};
	white-space: break-spaces;
`;
const Created = styled.div`
	${textStyles.uiTextS}

	display: inline-block;
	max-width: 100%;
	color: ${token.gray400};
	margin-top: ${token.spacing2};
`;
const InboxWrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	width: 500px;
	min-width: 500px;
	max-width: 500px;
`;
const InboxBody = styled.div`
	flex-shrink: 1;
	overflow-y: auto;
	max-height: 420px;
	margin-top: -4px;
`;
const FlexWrapper = styled.div`
	padding: 0 ${token.spacing3} 0 ${token.spacing5};
`;
const InboxHeader = styled.div`
	margin: ${token.spacing3} ${token.spacing5} ${token.spacing3} ${token.spacing5};
`;
const InboxTitle = styled.h2`
	${textStyles.headingS}

	margin: ${token.spacing6} 0 ${token.spacing4} ${token.spacing5};
`;
export {
  ActionsWrapper,
  BoxGrow,
  Created,
  DropdownWrapper,
  EmptyStateWrapper,
  FlexWrapper,
  InboxBody,
  InboxHeader,
  InboxTitle,
  InboxWrapper,
  ListItemStyled,
  ListStyled,
  StickyHeader,
  Subtitle,
  Title
};
//# sourceMappingURL=styles.js.map
